import { BlueCheckbox } from 'components/Checkbox/BlueCheckbox';
import { useTranslation } from 'react-i18next';
import { DELIVERY_ADDRESS_MODAL } from 'routes/DeliveryAddressModal/DeliveryAddressModal.const';
import { useDeliveryAddressForm } from 'routes/DeliveryAddressModal/hooks/useDeliveryAddressForm';

export const DeliveryAddressModalSaveCheckbox = () => {
  const { makeAddressDefault, setMakeAddressDefault } = useDeliveryAddressForm();
  const { t } = useTranslation();

  return (
    <BlueCheckbox
      label={t('deliveryAddressModal.saveCheckbox')}
      checked={makeAddressDefault}
      onChange={() => setMakeAddressDefault((v) => !v)}
      name={t('deliveryAddressModal.saveCheckbox')}
      data-testid={DELIVERY_ADDRESS_MODAL.saveCheckmarkTestId}
    />
  );
};
